import { Controller } from "stimulus"

export default class extends Controller {
  
  static targets = ["parentCategories", "searchInput"];

  searchCategory(e) {
    var categories = this.parentCategoriesTarget.querySelectorAll(".product-parent-category");
    var parentCategoriesLabels = this.parentCategoriesTarget.querySelectorAll('label.parent-category-label') 
    var subcategoriesLists = this.parentCategoriesTarget.querySelectorAll(".subcategories-list")
    var subcategoriesListLabels = this.parentCategoriesTarget.querySelectorAll('label.subcategory-label') 

    var matchingSubcategoriesbLabels = [...subcategoriesListLabels].filter((label) => label.textContent.toLowerCase().includes(this.searchInputTarget.value.toLowerCase()));
    var matchingParentCategoriesLabels = [...parentCategoriesLabels].filter((label) => label.textContent.toLowerCase().includes(this.searchInputTarget.value.toLowerCase()));


    if (this.searchInputTarget.value.length >= 2) {

      this.parentCategoriesTarget.querySelectorAll('label.parent-category-label').forEach((label) => label.parentElement.classList.add("hidden"));
      matchingParentCategoriesLabels.forEach((label) => label.parentElement.classList.remove("hidden"));
      

      matchingSubcategoriesbLabels.forEach((label) => {
        var parentCategoryID = label.dataset.parentCategoryId;
        this.parentCategoriesTarget.querySelector(`#parent_category_${parentCategoryID}_label_wrap`).classList.remove("hidden");
        label.parentElement.classList.remove("hidden");
      });

      subcategoriesLists.forEach((list) => {
        var currentListSubcategoriesListLabels = list.querySelectorAll('label.subcategory-label')
        var currentListHasMatchingSubcategories = matchingSubcategoriesbLabels.filter(label => [...currentListSubcategoriesListLabels].includes(label)).length > 0;
        if (currentListHasMatchingSubcategories) {
          //currentListSubcategoriesListLabels.forEach((subLabel) => subLabel.parentElement.classList.add("hidden"));
          list.classList.remove("hidden");
        } else {
          //subcategoriesLists.forEach((list) => list.classList.add("hidden"))
          list.classList.add("hidden");
        }



      })
      

    } else {
      this.parentCategoriesTarget.querySelectorAll('label.parent-category-label').forEach((label) => label.parentElement.classList.remove("hidden"));
      subcategoriesLists.forEach((list) => list.classList.add("hidden"))

    }
    
  }

}
